import { render, staticRenderFns } from "./YourDetails.vue?vue&type=template&id=1b49a617&scoped=true&"
import script from "./YourDetails.vue?vue&type=script&lang=js&"
export * from "./YourDetails.vue?vue&type=script&lang=js&"
import style0 from "./YourDetails.vue?vue&type=style&index=0&id=1b49a617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49a617",
  null
  
)

export default component.exports